const SHARED_SECRET = process.env.REACT_APP_REQUEST_SIGNING_SECRET as string;

async function generateRequestSignature(secret: string, message: string): Promise<string> {
  const encoder = new TextEncoder();
  const key = await crypto.subtle.importKey(
    "raw",
    encoder.encode(secret),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"],
  );
  const signatureBuffer = await crypto.subtle.sign("HMAC", key, encoder.encode(message));
  const bytes = new Uint8Array(signatureBuffer);
  let binary = "";
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

export async function signRequest(method: string, path: string): Promise<String> {
  const timestamp = Date.now().toString();

  const canonical = [method.toUpperCase(), path, timestamp].join("|");
  const signature = await generateRequestSignature(SHARED_SECRET, canonical);

  return `${timestamp}.${signature}`;
}
